<template>
  <div>
    <section class="hero-sec">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="hero-content">
              <h3>실제 신규 사업자 DB를 <b>합리적인 가격</b>으로 <b>무제한</b> 제공!</h3>
              <h3>상위 1% 영업사원들의 돈버는 비밀</h3>
              <h3>높은 계약율을 유지하는 최신디비</h3>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="hero-img">
              <img src="/assets/images/hero-img.png">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="econ-sec">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="econ-col">
              <div class="econ-inner">
                <router-link to="/portal">
                    <div class="econ-content">
                      <img src="/assets/images/econimg1.png" alt="">
                      <h6>포털DB</h6>
                      <p>Total <b>
                        <ICountUp
                          :delay="delay"
                          :endVal="summaryModel.filter(x => x.type == 'portal')[0]?.total"
                          :options="options"
                          @ready="onReady"
                          class="countBase"
                      >
                      </ICountUp></b>건<br>Today <b>
                        <ICountUp
                          :delay="delay"
                          :endVal="summaryModel.filter(x => x.type == 'portal')[0]?.today"
                          :options="options"
                          @ready="onReady"
                          class="countBase"
                      >
                      </ICountUp></b>건</p>
                    </div>
                </router-link>
              </div>
              <div class="econ-inner">
                <router-link to="./permitting">
                    <div class="econ-content">
                      <img src="/assets/images/econimg2.png" alt="">
                      <h6>인허가DB</h6>
                      <p>Total <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'permitting')[0]?.total"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp>
                      </b>건<br>Today <b>
                        <ICountUp
                          :delay="delay"
                          :endVal="summaryModel.filter(x => x.type == 'permitting')[0]?.today"
                          :options="options"
                          @ready="onReady"
                          class="countBase"
                      >
                      </ICountUp></b>건</p>
                    </div>
                </router-link>
              </div>
              <div class="econ-inner">
                <router-link to="/company">
                    <div class="econ-content">
                      <img src="/assets/images/econimg3.png" alt="">
                      <h6>기업DB</h6>
                      <p>Total <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'company')[0]?.total"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp>
                      </b>건<br>Today <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'company')[0]?.today"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp></b>건</p>
                    </div>
                </router-link>
              </div>
              <div class="econ-inner">
                <router-link to="/corporation">
                    <div class="econ-content">
                      <img src="/assets/images/econimg4.png" alt="">
                      <h6>법인DB</h6>
                      <p>Total <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'corp')[0]?.total"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp>
                      </b>건<br>Today <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'corp')[0]?.today"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp></b>건</p>
                    </div>
                </router-link>
              </div>
              <div class="econ-inner">
                <router-link to="/market">
                    <div class="econ-content">
                      <img src="/assets/images/econimg5.png" alt="">
                      <h6>마켓DB</h6>
                      <p>Total <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'market')[0]?.total"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp>
                      </b>건<br>Today <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'market')[0]?.today"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp></b>건</p>
                    </div>
                </router-link>
              </div>
              <div class="econ-inner">
                <router-link to="/phone">
                    <div class="econ-content">
                      <img src="/assets/images/econimg6.png" alt="">
                      <h6>휴대폰DB</h6>
                      <p>Total <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'phone')[0]?.total"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp>
                      </b>건<br>Today <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'phone')[0]?.today"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp></b>건</p>
                    </div>
                </router-link>
              </div>
              <div class="econ-inner">
                <router-link to="/email">
                    <div class="econ-content">
                      <img src="/assets/images/econimg7.png" alt="">
                      <h6>이메일DB</h6>
                      <p>Total <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'email')[0]?.total"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp>
                      </b>건<br>Today <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'email')[0]?.today"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp></b>건</p>
                    </div>
                </router-link>
              </div>
              <div class="econ-inner">
                <router-link to="/fax">
                    <div class="econ-content">
                      <img src="/assets/images/econimg8.png" alt="">
                      <h6>팩스DB</h6>
                      <p>Total <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'fax')[0]?.total"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp>
                      </b>건<br>Today <b>
                        <ICountUp
                            :delay="delay"
                            :endVal="summaryModel.filter(x => x.type == 'fax')[0]?.today"
                            :options="options"
                            @ready="onReady"
                            class="countBase"
                        >
                        </ICountUp></b>건</p>
                    </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="collect-sec">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="collect-col">
              <div class="collect-inner">
                <img src="/assets/images/collectimg1.gif" alt="">
              </div>
              <div class="collect-content">
                <h5>{{$dayjs().format('MM월 DD일')}} UPDATE</h5>
                <p>각 종 DB 실시간 수집 중!</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="collect-frame-col">
              <div class="collect-frame-inner">
                <h4>
                  <ICountUp
                      :delay="delay"
                      :endVal="summaryModel.filter(x => x.type == 'total')[0]?.total"
                      :options="options"
                      @ready="onReady"
                      class="countBase"
                  >
                  </ICountUp>
                </h4>
                <span>
								총 DB 수
							</span>
              </div>
              <div class="collect-frame-inner">
                <h4>
                  <ICountUp
                      :delay="delay"
                      :endVal="summaryModel.filter(x => x.type == 'total')[0]?.today"
                      :options="options"
                      @ready="onReady"
                      class="countBase"
                  >
                  </ICountUp>
                </h4>
                <span>
								오늘({{$dayjs().format('MM-DD')}}) 신규 등록된 DB
							</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="industry-sec">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="industry-heading">
						<span>
							<h6>BEST 인기업종</h6>
						</span>
            </div>
          </div>
          <div class="category-box">
            <div class="category-slick-box">
              <slick ref="slick" :options="slickOptions">
                <router-link :to="`/database/건설%2F제조`"><img src="/assets/images/main_slick_01.png" alt=""><p>건설/제조</p></router-link>
                <router-link :to="`/database/교육%2F학원`"><img src="/assets/images/main_slick_02.png" alt=""><p>교육/학원</p></router-link>
                <router-link :to="`/database/물류%2F창고`"><img src="/assets/images/main_slick_03.png" alt=""><p>물류/창고</p></router-link>
                <router-link :to="`/database/미용`"><img src="/assets/images/main_slick_04.png" alt=""><p>미용</p></router-link>
                <router-link :to="`/database/미디어`"><img src="/assets/images/main_slick_05.png" alt=""><p>미디어</p></router-link>
                <router-link :to="`/database/병원%2F건강`"><img src="/assets/images/main_slick_06.png" alt=""><p>병원/건강</p></router-link>
                <router-link :to="`/database/부동산`"><img src="/assets/images/main_slick_07.png" alt=""><p>부동산</p></router-link>
                <router-link :to="`/database/쇼핑%2F유통`"><img src="/assets/images/main_slick_08.png" alt=""><p>쇼핑/유통</p></router-link>
                <router-link :to="`/database/숙박업`"><img src="/assets/images/main_slick_09.png" alt=""><p>숙박업</p></router-link>
                <router-link :to="`/database/식%2F음료`"><img src="/assets/images/main_slick_10.png" alt=""><p>식/음료</p></router-link>
                <router-link :to="`/database/생활%2F편의`"><img src="/assets/images/main_slick_11.png" alt=""><p>생활/편의</p></router-link>
                <router-link :to="`/database/서비스`"><img src="/assets/images/main_slick_12.png" alt=""><p>서비스</p></router-link>
                <router-link :to="`/database/종교`"><img src="/assets/images/main_slick_13.png" alt=""><p>종교</p></router-link>
                <router-link :to="`/database/유흥`"><img src="/assets/images/main_slick_14.png" alt=""><p>유흥</p></router-link>
                <router-link :to="`/database/운동`"><img src="/assets/images/main_slick_15.png" alt=""><p>운동</p></router-link>
                <router-link :to="`/database/여행`"><img src="/assets/images/slick_16.png" alt=""><p>여행</p></router-link>
              </slick>
            </div>
            <button
                v-b-toggle="`allCategory`"
                class="allcategory-button"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#collapse-1`"
                :aria-expanded='true'
                :aria-controls="`collapse-1`"
            >
              <p>전체보기</p>
            </button>
            <b-collapse :id="`allCategory`" accordion="" role="tabpanel" class="allcategory-content">
              <div :id="`collapse-1`" class="">
                <div class="">
                  <table id="tablepress-2" class="tablepress tablepress-id-2">
                    <tbody class="row-striping row-hover">
                    <tr class="row-1">
                      <td class="column-1">건설/제조</td><td class="column-2">
                      <span v-for="(item) in categoryData['건설/제조']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-2">
                      <td class="column-1">교육/학원</td><td class="column-2">
                      <span v-for="(item) in categoryData['교육/학원']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-3">
                      <td class="column-1">물류/창고</td><td class="column-2">
                      <span v-for="(item) in categoryData['물류/창고']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-4">
                      <td class="column-1">미용</td><td class="column-2">
                      <span v-for="(item) in categoryData['미용']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-5">
                      <td class="column-1">미디어</td><td class="column-2">
                      <span v-for="(item) in categoryData['미디어']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-6">
                      <td class="column-1">병원/건강</td><td class="column-2">
                      <span v-for="(item) in categoryData['병원/건강']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-7">
                      <td class="column-1">부동산</td><td class="column-2">
                      <span v-for="(item) in categoryData['부동산']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-8">
                      <td class="column-1">쇼핑,유통</td><td class="column-2">
                      <span v-for="(item) in categoryData['쇼핑,유통']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-9">
                      <td class="column-1">숙박업</td><td class="column-2">
                      <span v-for="(item) in categoryData['숙박업']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-10">
                      <td class="column-1">식/음료</td><td class="column-2">
                      <span v-for="(item) in categoryData['식/음료']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-11">
                      <td class="column-1">생활/편의</td><td class="column-2">
                      <span v-for="(item) in categoryData['생활/편의']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-12">
                      <td class="column-1">서비스</td><td class="column-2">
                      <span v-for="(item) in categoryData['서비스']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-13">
                      <td class="column-1">운동</td><td class="column-2">
                      <span v-for="(item) in categoryData['운동']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-14">
                      <td class="column-1">여행</td><td class="column-2">
                      <span v-for="(item) in categoryData['여행']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-15">
                      <td class="column-1">유흥</td><td class="column-2">
                      <span v-for="(item) in categoryData['유흥']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    <tr class="row-16">
                      <td class="column-1">종교</td><td class="column-2">
                      <span v-for="(item) in categoryData['종교']" :key="item"><router-link :to="`/database/${item.includes('/') ? item.replaceAll('/', '%2F') : item }`">{{ item }}</router-link></span>
                    </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </section>

    <section class="extraction-sec">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="extraction-col1x">
						<span>
							<h2>포털DB</h2>
							<p>등록업체:<b class="c-total-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'portal')[0]?.total"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp></b></p>
							<p>Today 업데이트:<b class="c-today-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'portal')[0]?.today"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp>건</b></p>
						</span>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="extraction-col2x">
              <button class="excel-btn" type="button" @click="exportToExcel('portalTable','포털DB_샘플')">
                <img src="/assets/images/excel.svg" alt="">
                샘플 다운로드
              </button>
              <router-link to="/portal" class="arrow-btn">
                포털 DB 더보기
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-angle-right" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="extraction-table" v-if="isSummaryDataLoading == false">
              <table id="portalTable" class="table">
                <thead>
                <tr>
                  <th scope="col">DB추출일</th>
                  <th scope="col">업체명</th>
                  <th scope="col">연락처</th>
                  <th scope="col">업종</th>
                  <th scope="col">주소</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in summaryData.portal" :key = index>
                  <td>
                    <span>
											  <svg  v-if="$dayjs().isSame($dayjs(item.createDate), 'day')"  xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                              viewBox="0 0 100 100" fill="none">
                          <circle cx="50" cy="50" r="50" fill="#D32A2A"></circle>
                          <path
                              d="M68.375 71H59.0586L43.2969 48.0898H43.0039V71H31.8711V28.5781H41.3633L56.8906 51.3711H57.2422V28.5781H68.375V71Z"
                              fill="white"></path>
                        </svg>
                        {{ $dayjs().diff(item.createDate, "hours") > 24 ? $dayjs(item.createDate).format("YYYY-MM-DD") : $dayjs(item.createDate).fromNow() }}
										  </span>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.depth }}</td>
                  <td>{{ item.address }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="extraction-table" v-else>
              <b-skeleton-table
                  :rows="5"
                  :columns="5"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="extraction-sec extraction-sec2x">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="extraction-col1x">
						<span>
							<h2>인허가DB</h2>
							<p>등록업체:<b class="c-total-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'permitting')[0]?.total"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp></b></p>
							<p>Today 업데이트:<b class="c-today-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'permitting')[0]?.today"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp>건</b></p>
						</span>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="extraction-col2x">
              <button class="excel-btn" type="button" @click="exportToExcel('permittingTable','인허가DB_샘플')">
                <img src="/assets/images/excel.svg" alt="">
                샘플 다운로드
              </button>
              <router-link to="/permitting" class="arrow-btn">
                인허가 DB 더보기
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-angle-right" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="extraction-table" v-if="isSummaryDataLoading == false">
              <table id="permittingTable" class="table">
                <thead>
                <tr>
                  <th scope="col">DB추출일</th>
                  <th scope="col">업체명</th>
                  <th scope="col">연락처</th>
                  <th scope="col">업종</th>
                  <th scope="col">주소</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in summaryData.license" :key = index>
                  <td>
                    <span>
											  <svg  v-if="$dayjs().isSame($dayjs(item.createDate), 'day')"  xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                              viewBox="0 0 100 100" fill="none">
                          <circle cx="50" cy="50" r="50" fill="#D32A2A"></circle>
                          <path
                              d="M68.375 71H59.0586L43.2969 48.0898H43.0039V71H31.8711V28.5781H41.3633L56.8906 51.3711H57.2422V28.5781H68.375V71Z"
                              fill="white"></path>
                        </svg>
                        {{ $dayjs().diff(item.createDate, "hours") > 24 ? $dayjs(item.createDate).format("YYYY-MM-DD") : $dayjs(item.createDate).fromNow() }}
										  </span>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.depth }}</td>
                  <td>{{ item.address }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="extraction-table" v-else>
              <b-skeleton-table
                  :rows="5"
                  :columns="5"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="extraction-sec extraction-sec2x extraction-sec3x">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="extraction-col1x">
						<span>
							<h2>기업DB</h2>
							<p>등록업체:<b class="c-total-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'company')[0]?.total"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp></b></p>
							<p>Today 업데이트:<b class="c-today-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'company')[0]?.today"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp>건</b></p>
						</span>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="extraction-col2x">
              <button class="excel-btn" type="button" @click="exportToExcel('companyTable','기업DB_샘플')">
                <img src="assets/images/excel.svg" alt="">
                샘플 다운로드
              </button>
              <router-link to="/company" class="arrow-btn">
                기업 DB 더보기
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-angle-right" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="extraction-table" v-if="isSummaryDataLoading == false">
              <table id='companyTable' class="table">
                <thead>
                <tr>
                  <th scope="col">DB추출일</th>
                  <th scope="col">업체명</th>
                  <th scope="col">업종</th>
                  <th scope="col">규모</th>
                  <th scope="col">매출</th>
                  <th scope="col">직원수</th>
                  <th scope="col">주소</th>
                  <th scope="col">연락처</th>
                  <th scope="col">팩스</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in summaryData.company" :key = index>
                  <td>
                    <span>
											  <svg  v-if="$dayjs().isSame($dayjs(item.createDate), 'day')"  xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                              viewBox="0 0 100 100" fill="none">
                          <circle cx="50" cy="50" r="50" fill="#D32A2A"></circle>
                          <path
                              d="M68.375 71H59.0586L43.2969 48.0898H43.0039V71H31.8711V28.5781H41.3633L56.8906 51.3711H57.2422V28.5781H68.375V71Z"
                              fill="white"></path>
                        </svg>
                        {{ $dayjs().diff(item.createDate, "hours") > 24 ? $dayjs(item.createDate).format("YYYY-MM-DD") : $dayjs(item.createDate).fromNow() }}
										  </span>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.depth }}</td>
                  <td>{{ item.className }}</td>
                  <td>{{ item.totalPrice }}</td>
                  <td>{{ item.userCount }}</td>
                  <td>{{ item.address }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.fax }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="extraction-table" v-else>
              <b-skeleton-table
                  :rows="5"
                  :columns="9"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="extraction-sec extraction-sec2x">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="extraction-col1x">
						<span>
							<h2>마켓DB</h2>
							<p>등록업체:<b class="c-total-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'market')[0]?.total"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp></b></p>
							<p>Today 업데이트:<b class="c-today-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'market')[0]?.today"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp>건</b></p>
						</span>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="extraction-col2x">
              <button class="excel-btn" type="button" @click="exportToExcel('marketTable','마켓DB_샘플')">
                <img src="/assets/images/excel.svg" alt="">
                샘플 다운로드
              </button>
              <router-link to="/market" class="arrow-btn">
                마켓 DB 더보기
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-angle-right" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="extraction-table m-t" v-if="isSummaryDataLoading == false">
              <table id="marketTable" class="table">
                <thead>
                <tr>
                  <th scope="col">DB추출일</th>
                  <th scope="col">업체명</th>
                  <th scope="col">대표자명</th>
                  <th scope="col">연락처</th>
                  <th scope="col">이메일</th>
                  <th scope="col">업종</th>
                  <th scope="col">주소</th>
                  <th scope="col">샵링크</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in summaryData.market" :key = index>
                  <td>
                    <span>
											  <svg  v-if="$dayjs().isSame($dayjs(item.createDate), 'day')"  xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                              viewBox="0 0 100 100" fill="none">
                          <circle cx="50" cy="50" r="50" fill="#D32A2A"></circle>
                          <path
                              d="M68.375 71H59.0586L43.2969 48.0898H43.0039V71H31.8711V28.5781H41.3633L56.8906 51.3711H57.2422V28.5781H68.375V71Z"
                              fill="white"></path>
                        </svg>
                        {{ $dayjs().diff(item.createDate, "hours") > 24 ? $dayjs(item.createDate).format("YYYY-MM-DD") : $dayjs(item.createDate).fromNow() }}
										  </span>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.depth }}</td>
                  <td>{{ item.address }}</td>
                  <td><a href="" @click="GoUrl(item.link, $event)"><img src="/assets/images/link_btn.png"></a></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="extraction-table" v-else>
              <b-skeleton-table
                  :rows="5"
                  :columns="8"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="extraction-sec extraction-sec2x">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="extraction-col1x">
						<span>
							<h2>법인DB</h2>
							<p>등록업체:<b class="c-total-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'corp')[0]?.total"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp></b></p>
							<p>Today 업데이트:<b class="c-today-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'corp')[0]?.today"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp>건</b></p>
						</span>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="extraction-col2x">
              <button class="excel-btn" type="button" @click="exportToExcel('corpTable','법인DB_샘플')">
                <img src="/assets/images/excel.svg" alt="">
                샘플 다운로드
              </button>
              <router-link to="/corp" class="arrow-btn">
                법인 DB 더보기
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-angle-right" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="extraction-table" v-if="isSummaryDataLoading == false">
              <table id="corpTable" class="table">
                <thead>
                <tr>
                  <th scope="col">DB추출일</th>
                  <th scope="col">업체명</th>
                  <th scope="col">연락처</th>
                  <th scope="col">팩스</th>
                  <th scope="col">이메일</th>
                  <th scope="col">업종</th>
                  <th scope="col">주소</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in summaryData.corp" :key = index>
                  <td>
                    <span>
											  <svg  v-if="$dayjs().isSame($dayjs(item.createDate), 'day')"  xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                              viewBox="0 0 100 100" fill="none">
                          <circle cx="50" cy="50" r="50" fill="#D32A2A"></circle>
                          <path
                              d="M68.375 71H59.0586L43.2969 48.0898H43.0039V71H31.8711V28.5781H41.3633L56.8906 51.3711H57.2422V28.5781H68.375V71Z"
                              fill="white"></path>
                        </svg>
                        {{ $dayjs().diff(item.createDate, "hours") > 24 ? $dayjs(item.createDate).format("YYYY-MM-DD") : $dayjs(item.createDate).fromNow() }}
										  </span>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.fax }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.depth }}</td>
                  <td>{{ item.address }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="extraction-table" v-else>
              <b-skeleton-table
                  :rows="5"
                  :columns="7"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="extraction-sec extraction-sec2x">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="extraction-col1x">
						<span>
							<h2>휴대폰DB</h2>
							<p>등록업체:<b class="c-total-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'phone')[0]?.total"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp></b></p>
							<p>Today 업데이트:<b class="c-today-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'phone')[0]?.today"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp>건</b></p>
						</span>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="extraction-col2x">
              <button class="excel-btn" type="button" @click="exportToExcel('phoneTable','휴대폰DB_샘플')">
                <img src="/assets/images/excel.svg" alt="">
                샘플 다운로드
              </button>
              <router-link to="/phone" class="arrow-btn">
                휴대폰 DB 더보기
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-angle-right" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="extraction-table" v-if="isSummaryDataLoading == false">
              <table id="phoneTable" class="table">
                <thead>
                <tr>
                  <th scope="col">DB추출일</th>
                  <th scope="col">업체명</th>
                  <th scope="col">연락처</th>
                  <th scope="col">업종</th>
                  <th scope="col">주소</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in summaryData.phone" :key = index>
                  <td>
                    <span>
											  <svg  v-if="$dayjs().isSame($dayjs(item.createDate), 'day')"  xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                              viewBox="0 0 100 100" fill="none">
                          <circle cx="50" cy="50" r="50" fill="#D32A2A"></circle>
                          <path
                              d="M68.375 71H59.0586L43.2969 48.0898H43.0039V71H31.8711V28.5781H41.3633L56.8906 51.3711H57.2422V28.5781H68.375V71Z"
                              fill="white"></path>
                        </svg>
                        {{ $dayjs().diff(item.createDate, "hours") > 24 ? $dayjs(item.createDate).format("YYYY-MM-DD") : $dayjs(item.createDate).fromNow() }}
										  </span>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.depth }}</td>
                  <td>{{ item.address }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="extraction-table" v-else>
              <b-skeleton-table
                  :rows="5"
                  :columns="5"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="extraction-sec extraction-sec4x">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="extraction-col1x">
						<span>
							<h2>이메일DB</h2>
							<p>등록업체:<b class="c-total-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'email')[0]?.total"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp></b></p>
							<p>Today 업데이트:<b class="c-today-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'email')[0]?.today"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp>건</b></p>
						</span>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="extraction-col2x">
              <button class="excel-btn" type="button" @click="exportToExcel('emailTable','이메일DB_샘플')">
                <img src="/assets/images/excel.svg" alt="">
                샘플 다운로드
              </button>
              <router-link to="/email" class="arrow-btn">
                이메일 DB 더보기
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-angle-right" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="extraction-table" v-if="isSummaryDataLoading == false">
              <table id="emailTable" class="table">
                <thead>
                <tr>
                  <th scope="col">DB추출일</th>
                  <th scope="col">업체명</th>
                  <th scope="col">이메일</th>
                  <th scope="col">연락처</th>
                  <th scope="col">업종</th>
                  <th scope="col">주소</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in summaryData.email" :key = index>
                  <td>
                    <span>
											  <svg  v-if="$dayjs().isSame($dayjs(item.createDate), 'day')"  xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                              viewBox="0 0 100 100" fill="none">
                          <circle cx="50" cy="50" r="50" fill="#D32A2A"></circle>
                          <path
                              d="M68.375 71H59.0586L43.2969 48.0898H43.0039V71H31.8711V28.5781H41.3633L56.8906 51.3711H57.2422V28.5781H68.375V71Z"
                              fill="white"></path>
                        </svg>
                        {{ $dayjs().diff(item.createDate, "hours") > 24 ? $dayjs(item.createDate).format("YYYY-MM-DD") : $dayjs(item.createDate).fromNow() }}
										  </span>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.depth }}</td>
                  <td>{{ item.address }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="extraction-table" v-else>
              <b-skeleton-table
                  :rows="5"
                  :columns="6"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="extraction-sec extraction-sec4x">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="extraction-col1x">
						<span>
							<h2>팩스DB</h2>
							<p>등록업체:<b class="c-total-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'fax')[0]?.total"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp></b></p>
							<p>Today 업데이트:<b class="c-today-cnt"> <ICountUp
                  :delay="delay"
                  :endVal="summaryModel.filter(x => x.type == 'fax')[0]?.today"
                  :options="options"
                  @ready="onReady"
                  class="countBase"
              ></ICountUp>건</b></p>
						</span>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="extraction-col2x">
              <button class="excel-btn" type="button" @click="exportToExcel('faxTable','팩스DB_샘플')">
                <img src="/assets/images/excel.svg" alt="">
                샘플 다운로드
              </button>
              <router-link to="/fax" class="arrow-btn">
                팩스 DB 더보기
                <svg aria-hidden="true" class="e-font-icon-svg e-fas-angle-right" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="extraction-table" v-if="isSummaryDataLoading == false">
              <table id="faxTable" class="table">
                <thead>
                <tr>
                  <th scope="col">DB추출일</th>
                  <th scope="col">업체명</th>
                  <th scope="col">팩스번호</th>
                  <th scope="col">연락처</th>
                  <th scope="col">업종</th>
                  <th scope="col">주소</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in summaryData.fax" :key = index>
                  <td>
                    <span>
											  <svg  v-if="$dayjs().isSame($dayjs(item.createDate), 'day')"  xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                              viewBox="0 0 100 100" fill="none">
                          <circle cx="50" cy="50" r="50" fill="#D32A2A"></circle>
                          <path
                              d="M68.375 71H59.0586L43.2969 48.0898H43.0039V71H31.8711V28.5781H41.3633L56.8906 51.3711H57.2422V28.5781H68.375V71Z"
                              fill="white"></path>
                        </svg>
                        {{ $dayjs().diff(item.createDate, "hours") > 24 ? $dayjs(item.createDate).format("YYYY-MM-DD") : $dayjs(item.createDate).fromNow() }}
										  </span>
                  </td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.fax }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.depth }}</td>
                  <td>{{ item.address }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="extraction-table" v-else>
              <b-skeleton-table
                  :rows="5"
                  :columns="6"
                  :table-props="{ bordered: true, striped: true }"
              ></b-skeleton-table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="main-bottom-sec">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="main-notice-title">공지사항</div>
            <router-link to="./contact-us">
              <div class="main-notice-box">
                <ul v-if="noticeData != null">
                  <li v-for="(item) in noticeData.responseData" :key="item.idx">
                    {{ item.title }}
                  </li>
                </ul>
              </div>
            </router-link>
          </div>
          <div class="col-12 col-lg-6">
            <div class="main-faq-title">자주하는 질문</div>
            <div class="main-faq-box">
              <div class="faq-box" v-for="(item, index) in faqList" :key="item.idx">
                <button
                    v-b-toggle="`faq-${index}`"
                    class="faq-title"
                    type="button"
                    :aria-expanded="item.show ? 'true' : 'false'"
                    :aria-controls="`faq-col-${index}`"
                >
                  <p>{{ item.title }}</p>
                </button>
                <b-collapse :id="`faq-${index}`" role="tabpanel" class="faq-content" accordion="faq-accordion">
                  <div :id="`faq-col-${index}`" v-html="item.content">
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <allCategory class="test" ref="allCategoryModal"/>
  </div>
</template>

<script>
import {oepnMarketAPI, naverPlaceAPI, dbAPI, noticeAPI} from '@/api/index';
import ICountUp from 'vue-countup-v2';
import allCategory from './Modals/AllCategory'
import * as XLSX from 'xlsx';
import {faqAPI} from "@/api/faq";

export default {
  components: {
    ICountUp,
    allCategory
  },
  data() {
    return {
      noticeData : {

      },
      faqList : [],
      summaryData :{
      },
      summaryModel:[
          {
            "type": "portal",
            "total": 100000,
            "today": 0
          },
          {
            "type": "permitting",
            "total": 100000,
            "today": 0
          },
          {
            "type": "company",
            "total": 100000,
            "today": 0
          },
          {
            "type": "corp",
            "total": 100000,
            "today": 0
          },
          {
            "type": "market",
            "total": 100000,
            "today": 0
          },
          {
            "type": "phone",
            "total": 100000,
            "today": 0
          },
          {
            "type": "email",
            "total": 100000,
            "today": 0
          },
          {
            "type": "fax",
            "total": 100000,
            "today": 0
          },
          {
            "type": "total",
            "total": 100000,
            "today": 0
          }
      ],
      isSummaryLoading:false,
      isSummaryDataLoading:false,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: ''
      },
      delay: 1000,
      isOpenMarketLoding: false,
      openMarketItemModel: [],
      openMarketItemModelCount: 0,
      openMarketItemTotalCount: {
        monthday: 0,
        today: 0,
        total: 0,
        yesterday: 0
      },

      isNaverPlaceLoding: false,
      naverPlaceItemModel: [],
      naverPlaceItemModelCount: 0,
      naverPlaceItemTotalCount: {
        monthday: 0,
        today: 0,
        total: 0,
        yesterday: 0
      },
      slickOptions: {
        slidesToShow: 10,
        infinite : false,
        responsive: [
          {
            breakpoint: 1024, // 화면 너비가 1024px 이하일 때
            settings: {
              slidesToShow: 8,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 770, // 화면 너비가 600px 이하일 때
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 570, // 화면 너비가 600px 이하일 때
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 430, // 화면 너비가 600px 이하일 때
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 350, // 화면 너비가 600px 이하일 때
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
        ],
        // Any other options that can be got from plugin documentation
      },
      categoryData : {
        "건설/제조" : [
          "공장", "제조", "건설", "공사", "인테리어", "간판", "조경", "페인트/도장", "현수막", "지게차", "건축업", "건축사무소", "의류제작", "인력사무소", "샷시", "철거", "폐기물", "금속제조", "사출", "석재"
        ],
        "교육/학원": [
          "유치원", "어린이집", "초등학교", "중학교", "고등학교", "대학교", "학원/교습", "학습지", "독서실", "도서관"
        ],
        "물류/창고": [
          "물류", "운송", "창고"
        ],
        "미용": [
          "미용실", "피부과", "네일아트", "피부/체형관리", "마사지", "다이어트", "왁싱/제모"
        ],
        "미디어": [
          "엔터테인먼트", "컨텐츠제작", "방송/영상", "게임제작", "마케팅"
        ],
        "병원/건강": [
          "병원", "한의원", "성형외과", "산후조리원", "요양원", "약국", "장례/화장/납골당", "건강기능식품", "치과용품"
        ],
        "부동산": [
          "공인중개사", "시행사", "건물관리", "이사업체", "아파트관리실"
        ],
        "쇼핑,유통" :[
            "슈퍼/마트", "아울렛", "백화점", "복권,로또", "금은방", "중고거래", "중고차", "오토바이", "정육점", "주유소", "철물점", "출판사", "보안/CCTV", "가구", "휴대폰대리점", "의류/패션", "공방", "도서/문구/사무용품", "반려동물", "화장품", "자동차용품", "캠핑용품", "낚시용품", "과일"
        ],
        "숙박업": [
          "호텔", "모텔", "펜션", "리조트", "게스트하우스", "고시원/고시텔", "캠핑장/야영장", "캠핑카", "연수원/수련원"
        ],
        "식/음료": [
          "음식점", "술집", "카페/디저트", "키즈카페", "애견카페", "프랜차이즈", "반찬가게"
        ],
        "생활/편의": [
          "찜질방", "사우나", "안경점", "꽃집", "세탁/빨래방", "카센터/정비", "렌터카", "농장", "사진관/스튜디오", "인쇄소/복사/제본", "에어컨", "은행", "보험", "경로당", "경호", "환전소", "세차장", "재활용"
        ],
        "서비스": [
          "법률사무소", "법무사", "세무사무소", "행정사사무소", "관공서/공공기관", "협회/단체", "협동조합", "결혼/웨딩", "철학관", "컴퓨터/컴퓨터수리", "사회/복지", "배달대행", "청소", "소프트웨어개발", "심부름센터/흥신소"
        ],
        "운동": [
          "헬스장", "필라테스", "요가", "골프", "당구장", "볼링장", "탁구장", "수영장", "배드민턴장", "테니스장", "검도"
        ],
        "여행": [
          "낚시터", "박물관", "미술관", "공연장", "수족관"
        ],
        "유흥": [
          "노래방", "단란주점", "유흥주점", "나이트클럽", "PC방"
        ],
        "종교": [
          "교회", "성당/천주교", "절/불교"
        ]
      },
    }
  },
  async created() {
    this.isSummaryDataLoading = true;
    this.isSummaryLoading = true;
    await this.GetSummary()
    await this.GetSummaryData()
    await this.GetNotice();
    await this.GetFaq();
    this.isSummaryDataLoading = false;
    this.isSummaryLoading = false;
  },
  methods: {
    exportToExcel(tableId, fileName) {
      const table = document.getElementById(tableId);
      const workbook = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });
      XLSX.writeFile(workbook, fileName+'.xlsx');
    },
    onReady: function(instance, CountUp) {
      const that = this;
      if(that.endVal>0){
      instance.update(that.endVal);
      }
    },
    async GetSummaryData() {
      this.isSummaryDataLoading = true;
      const itemResponse = await dbAPI.GetSummaryData();
      if(itemResponse.success == true){
        this.summaryData = itemResponse.data;
      }
      this.isSummaryDataLoading = false
    },
    async GetSummary() {
      this.isSummaryLoading = true;
      const itemResponse = await dbAPI.GetSummary();
      if(itemResponse.success == true){
        this.summaryModel = itemResponse.data.summaries;
      }
      this.isSummaryLoading = false
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch (error) {
      }
    },
    next() {
      this.$refs.slick.prev();
    },

    prev() {
      this.$refs.slick.next();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick();
    },
    allCategoryModalOpen() {
      this.$refs.allCategoryModal.open();
    },
    async GetNotice(){
      let response = await noticeAPI.GetNoticeList("", 1)
      if(response.success == true){
        this.noticeData = response
      }
    },
    async GetFaq(){
      let response = await faqAPI.GetFaqList(1)
      if(response.success == true) {
        response.data.forEach(x=> {
          x.show = false
        })
        this.faqList = response.data
      }
    },
    GoUrl(url, event){
      event.preventDefault();
      if (url == '' || url == 'htt**'){
        alert("마켓 URL을 확인할 수 없습니다.");
      }else{
        window.open(url, '_blank');
      }
    },
  },
}
</script>

<style scoped>

</style>